/**
 * The sections of one company's page, in display order, as the address names
 * them in `?aba=`. Shared by the page that draws the strip and by the paths
 * that send somebody back to one section, so the two cannot spell a tab
 * differently. The first is the default.
 */
export const COMPANY_TABS = {
  geral: 'Geral',
  regras: 'Validações e regras',
  contratos: 'Contratos',
  segurados: 'Segurados',
  usuarios: 'Usuários',
} as const;

export type CompanyTab = keyof typeof COMPANY_TABS;

/** The tablist's accessible name. */
export const COMPANY_TABS_LABEL = 'Seções da empresa';
